(function () {
    "use strict";

    angular
        .module("stSecurity", ["ngCookies"])
        .constant("AUTH_EVENTS", {
            notAuthenticated: "auth-not-authenticated",
            notAuthorized: "auth-not-authorized"
        })
        .factory("stHttpInterceptor", stHttpInterceptor)
        .factory("stAuthFactory", authFactory)
        .factory("stUtilsFactory", utilsFactory)
        .config(config);


    function config($httpProvider) {
        $httpProvider.interceptors.push("stHttpInterceptor");
    }
    config.$inject = ["$httpProvider"];


    function stHttpInterceptor($q, $rootScope, $injector, utils, AUTH_EVENTS) {
        let $http, loginModal; // need to get at runtime to avoid circular dependency
        return {
            'request': config => {
                const token = utils.token();
                if (token) {
                    config.headers.Authorization = `${token}`;
                }

                return config || $q.when(config);
            },
            'responseError': response => {
                if (response.status === 401) {
                        $http = $http || $injector.get("$http");
                        loginModal = loginModal || $injector.get("loginModal");
                        return loginModal().then(() => $http(response.config));
                }

                if (response.status === 403) {
                    $rootScope.$broadcast(AUTH_EVENTS.notAuthorized);
                }

                return $q.reject(response);
            }
        };
    }
    stHttpInterceptor.$inject = ["$q", "$rootScope", "$injector", "stUtilsFactory", "AUTH_EVENTS"];


    function authFactory($http, $location, $cookies, utils) {
        return {
            session: () => {
                const token = utils.token();
                return $http.get(`/api/security/session/${token}/`);
            },
            authorize: abilities => {
                const token = utils.token();
                return $http.post("/api/users/authorize", { token, abilities });
            }
        };
    }
    authFactory.$inject = ["$http", "$location", "$cookies", "stUtilsFactory", "userFactory"];


    function utilsFactory($cookies) {
        return {
            token: () => $cookies.get("stcart")
        };
    }
    utilsFactory.$inject = ["$cookies"];

})();